export default {
  'common.time.minutes': '分钟',
  'common.monday': '周一',
  'common.tuesday': '周二',
  'common.wednesday': '周三',
  'common.thursday': '周四',
  'common.friday': '周五',
  'common.saturday': '周六',
  'common.sunday': '周日',
  'common.sunday.fullFormat': '周日',
  'common.monday.fullFormat': '周一',
  'common.all': '所有',
  'common.filter': '筛选',
  'common.am': '上午',
  'common.pm': '下午',
  'common.here': '此处',
  'pageConstruction.subtitle': '对不起， 您访问的页面正在建设中。',
  'page404.subtitle': '对不起， 您访问的页面不存在。',
  'page403.subtitle': '对不起， 您无权访问此页面。',
  'content403.subtitle': '对不起，您无权访问此区域。',
  'smart-ordering-disabled': '扫码点餐服务暂时未对您开通。请联系本地服务团队开通此功能。',
  'access-declined': '无操作权限，如果您想被允许进行此操作，请联系餐厅老板。',
  'operation-self-declined': '无法对您本人此资源执行该操作',
  'load-menu-failed': '对不起，请求用户菜单失败，请重试',
  'fetching-data': '请求数据中...',
  'saving-data': '保存数据中...',
  'loading-image': '加载图片中...',
  'reload-permissionCodes': '重新加载用户权限',
  'pagination.summary': '第 {start}-{end} 条，共 {total} 条记录',
  'pageError.subtitle': '非常抱歉，某些地方运行出错了，我们团队已接收到错误并处理。',
  'notice.constructing': '此功能正在开发中',
  'save-prompt-content-on-leave': '是否在离开此页面前保存修改',
  'logout-prompt': '确认要登出吗？',
  'toggle-on': '是',
  'toggle-off': '否',
  'restaurant-unactivated': '在餐厅激活前你无法访问此页面。',
  required: '必填',
  existed: '已存在',
  optional: '可选',
  requiredSelection: '必选',
  paid: '带薪',
  unpaid: '无薪',
  'reload-preference': '加载设置失败，点击重试',
  'common.field.startTime': '开始时间',
  'common.field.endTime': '结束时间',
  'common.field.available': '启用',
  'common.field.action': '操作',
  'common.field.date': '日期',
  'common.originalSize': '原始尺寸：',
  'common.max': '最大值',
  'common.default': '默认值',
  'common.retryOnFailed': '加载失败，点击重试',
  'reload-image': '图片加载失败，点击重新加载',
  'commom.previous': '上一个',
  'commom.next': '下一个',
  'common.deleted': '已删除',
  'common.days': '天',
  'common.hours': '小时',
  'common.noData': '无数据',
  'common.from.less.than.to': '开始时间必须小于结束时间',
  'common.to.more.than.from': '结束时间必须大于开始时间',
  'common.expandAll': '展开全部',
  'common.collapseAll': '收起全部',
  'common.searchFor': '搜索',
  'common.pleaseEnter': '请输入',
  'common.y': '是',
  'common.n': '否',
  'common.searchResult': '({count}个匹配的项目)',
  'common.required': '必填',
  'common.day': '天',
  'common.time.overlap': '当前的营业时间段有重叠，请合并营业时间并重新设置。',
  'common.multiple': '多选',
  'common.single': '单选',
  'common.reload-message.default': '数据加载失败，点击重试',
  'common.to.from.cannot.equal': '开始时间与结束时间不能相同',
  'common.status.active': '启用',
  'common.status.inactive': '未启用',
};
